import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { services } from "@/data/siteConfig";
import { SectionHeader } from "@/components/SectionHeader";
import { ServiceCard } from "@/components/ServiceCard";
import { RevealGroup, RevealItem } from "@/components/Reveal";

export const ServicesPreview = () => (
  <section className="grain relative bg-ink py-24 md:py-32" data-testid="services-preview">
    <div className="relative z-10 mx-auto max-w-[1440px] px-5 md:px-8">
      <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <SectionHeader
          overline="Safe & Vault Services"
          title="Complete safe & vault services"
          description="Safe opening, moving, removal, disposal, installation, lock repair, keypad replacement and retrofits — handled with care, precision and honest advice."
        />
        <Link
          to="/services"
          data-testid="services-all-link"
          className="group inline-flex items-center gap-2 font-heading text-sm font-bold uppercase tracking-wide text-gold transition-colors hover:text-gold-soft"
        >
          All Services
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </div>

      <RevealGroup className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {services.slice(0, 6).map((s, i) => (
          <RevealItem key={s.slug}>
            <ServiceCard service={s} index={i + 1} testid={`service-${s.slug}`} />
          </RevealItem>
        ))}
      </RevealGroup>
    </div>
  </section>
);
